export function attachStyle(target, href) {
  const style = document.createElement('link');

  style.href = href;
  style.rel = 'stylesheet';
  style.type = 'text/css';

  target?.append(style);
}
